<div class="container-fluid bg-dark text-light shadow">
     
          <div class="d-flex justify-content-between align-items-center">
               <div class="col-lg-3">
                    <h3 (click)="toggleNavOnMobile()" class="mt-2 toggleNavOnMobile">CRM APP</h3>
               </div>
               <nav class="text-end col-lg-9">
                    <span><i class="headerIcon fa fa-user-circle me-2" aria-hidden="true"></i><span class="hideInMobile">{{user.email || 'Loading...'}}</span></span>
                   <button (click)="logout()" class=" badge ms-3 btn-danger"><i class="fa fa-sign-out" aria-hidden="true"></i>
                    Logout</button>
               </nav>
          </div>
  
</div>